import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { SubNavOption } from "@webapp/navigation/models/sub-nav-options.models";
import { BaseSubNav } from "../services/base-sub-nav";
import { from, iif, map, Observable, of } from "rxjs";
import { ICollection } from "@gtmhub/models";
import { INavItem } from "@webapp/navigation/models/nav-items-list.models";
import { SuggestedFacade } from "@webapp/navigation/services/uxcustomization/suggested/suggested.facade.service";
import { AccountService } from "@gtmhub/accounts/accounts-service";
import { FeatureFlag } from "@gtmhub/featureToggle/models";
import { FeatureToggleService } from "@gtmhub/featureToggle";
import NavigationItemsMediator from "@webapp/navigation/services/uxcustomization/navigation-items.mediator.service";

@Component({
  selector: "gh-people-sub-navigation",
  templateUrl: "./people-sub-navigation.component.html",
})
export class PeopleSubNavigationComponent extends BaseSubNav implements OnInit {
  @Output() private titleChange = new EventEmitter<string>();
  public options: SubNavOption[] = [
    { label: "Employees", state: "gtmhub.employees" },
    { label: "Teams", state: "gtmhub.teams", showOptionCondition$: of(this.accountService.featureAvailable("people.teams")) },
    { label: "Org chart", state: "gtmhub.organization_chart", showOptionCondition$: this.showOrgChart() },
  ];
  public suggested$: Observable<ICollection<INavItem>>;
  private sectionTitle = "People";

  public constructor(
    private suggestedFacade: SuggestedFacade,
    private accountService: AccountService,
    private featureToggleService: FeatureToggleService,
    protected navigationItemsMediator: NavigationItemsMediator
  ) {
    super();
    this.setupEntityTypes(["user", "team"], "people");

    this.suggested$ = this.suggestedFacade.getSuggestedTeams$();
  }

  public ngOnInit(): void {
    super.ngOnInit();
    this.titleChange.emit(this.sectionTitle);
  }

  protected itemMarkedAsFavorite(item: INavItem): void {
    this.suggestedFacade.removeSuggestedItem(item.id, "people");
  }

  private showOrgChart(): Observable<boolean> {
    return iif(
      () => this.accountService.featureAvailable("people.organization"),
      from(this.featureToggleService.isFeatureAvailable(FeatureFlag.OrganizationChartV2)).pipe(map((featureFlagEnabled) => featureFlagEnabled)),
      of(false)
    );
  }
}
